module.exports = "/fonts/vendor/@fortawesome/fontawesome-pro/webfa-light-300.eot?40ee3238f2e772740e226db30d40de97";